<template>
  <div id="systemFeedback" class="page-wrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>数据趋势</el-breadcrumb-item>
      <el-breadcrumb-item>人员-操作行为数据埋点</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          人员-操作行为数据埋点
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="全部人员" :label-width="formLabelWidth">
            <el-select v-model="userids" placeholder="请选择" size="small" clearable multiple>
              <el-option
                v-for="item in statisticalArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计时间" :label-width="formLabelWidth">
            <el-date-picker
              size="small"
              v-model="searchformDate2"
              type="month"
              placeholder="选择月"
              clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
        <el-col :span="24">
          <el-button @click="downTable(1)" type="primary" size="small" :loading="downTableTrue" style="margin-bottom: 8px;">导出</el-button>
        </el-col>
      </el-row>
      <el-table @sort-change="sortChange" :data="tableData" style="width: 100%;margin-top: 5px;" v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="人员">
        </el-table-column>
        <el-table-column prop="syncdatemonth" label="日期" sortable="custom">
        </el-table-column>
        <el-table-column prop="brmnum" label="品牌">
        </el-table-column>
        <el-table-column prop="shopwhitenum" label="店铺(白)">
        </el-table-column>
        <el-table-column prop="shopgreynum" label="店铺(灰)">
        </el-table-column>
        <el-table-column prop="itemlistnum" label="商品">
        </el-table-column>
        <el-table-column prop="markingnum" label="打标">
        </el-table-column>
        <el-table-column prop="lowpricenum" label="违规">
        </el-table-column>
        <el-table-column prop="lowpriceexcelnum" label="违规数据下载数埋点">
        </el-table-column>
        <el-table-column prop="synchronousnum" label="同步每日违规点击数">
        </el-table-column>
        <el-table-column prop="synchronousbannum" label="禁售同步点击数">
        </el-table-column>
        <el-table-column prop="noticenum" label="通知">
        </el-table-column>
        <el-table-column prop="noticeexcelnum" label="通知数据下载数">
        </el-table-column>
        <el-table-column prop="reviewnum" label="复查">
        </el-table-column>
        <el-table-column prop="reviewclicknum" label="复查数据点击数">
        </el-table-column>
        <el-table-column prop="reviewtimeoutnum" label="复查超时">
        </el-table-column>
        <el-table-column prop="reportnum" label="违规举报">
        </el-table-column>
        <el-table-column prop="inreportnum" label="未结案">
        </el-table-column>
        <el-table-column prop="reportsuccessnum" label="已结案">
        </el-table-column>
        <el-table-column prop="complaintsexcelnum" label="投诉报表下载数">
        </el-table-column>
        <el-table-column prop="brmstandardnum" label="品牌标准模板报表">
        </el-table-column>
        <el-table-column prop="itemlistlinkexcelnum" label="重点商品链接数量统计">
        </el-table-column>
        <el-table-column prop="shopkeyexcelnum" label="各店铺重点品多件组合装平均最违规统计">
        </el-table-column>
        <el-table-column prop="aggregationexcelnum" label="线上秩序维护汇总">
        </el-table-column>
        <el-table-column prop="platformreviewexcelnum" label="每日违规各平台违规链接情况统计">
        </el-table-column>
        <el-table-column prop="shopreviewexcelnum" label="每日违规店铺违规链接情况统计">
        </el-table-column>
        <el-table-column prop="productreviewexcelnum" label="每日重点品违规链接数量统计">
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>

    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          人员明细
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="全部人员" :label-width="formLabelWidth">
            <el-select v-model="userids2" placeholder="请选择" size="small" clearable multiple>
              <el-option
                v-for="item in statisticalArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计时间" :label-width="formLabelWidth">
            <el-date-picker
            v-model="searchformDate"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            range-separator="~"
            size="small" clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" class="search-btn" @click="oneStep2()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
        <el-col :span="24">
          <el-button @click="downTable(2)" type="primary" size="small" clearable :loading="downTableTrue2" style="margin-bottom: 8px;">导出</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData2" style="width: 100%;margin-top: 5px;" v-loading="tableLoading2" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="人员">
        </el-table-column>
        <el-table-column prop="syncdate" label="日期" width="100">
        </el-table-column>
        <el-table-column prop="brmnum" label="品牌">
        </el-table-column>
        <el-table-column prop="itemlistnum" label="商品入库">
        </el-table-column>
        <el-table-column prop="markingnum" label="打标">
        </el-table-column>
        <el-table-column prop="lowpricenum" label="违规">
        </el-table-column>
        <el-table-column prop="lowpriceexcelnum" label="违规数据下载数埋点">
        </el-table-column>
        <el-table-column prop="synchronousnum" label="违规同步点击数">
        </el-table-column>
        <el-table-column prop="synchronousbannum" label="禁售同步点击数">
        </el-table-column>
        <el-table-column prop="noticenum" label="通知">
        </el-table-column>
        <el-table-column prop="noticeexcelnum" label="通知数据下载数">
        </el-table-column>
        <el-table-column prop="reviewnum" label="复查">
        </el-table-column>
        <el-table-column prop="reviewclicknum" label="复查数据点击数">
        </el-table-column>
        <el-table-column prop="reviewtimeoutnum" label="复查超时">
        </el-table-column>
        <el-table-column prop="complaintsexcelnum" label="投诉报表下载数">
        </el-table-column>
        <el-table-column prop="brmstandardnum" label="品牌标准模板报表">
        </el-table-column>
        <el-table-column prop="itemlistlinkexcelnum" label="重点商品链接数量统计">
        </el-table-column>
        <el-table-column prop="shopkeyexcelnum" label="各店铺重点品多件组合装平均最违规统计">
        </el-table-column>
        <el-table-column prop="aggregationexcelnum" label="线上秩序维护汇总">
        </el-table-column>
        <el-table-column prop="platformreviewexcelnum" label="每日违规各平台违规链接情况统计">
        </el-table-column>
        <el-table-column prop="shopreviewexcelnum" label="每日违规店铺违规链接情况统计">
        </el-table-column>
        <el-table-column prop="productreviewexcelnum" label="每日重点品违规链接数量统计">
        </el-table-column>
        <el-table-column prop="noticerectificationnum" label="通知整改数据统计">
        </el-table-column>
        <el-table-column prop="reviewdealwithnum" label="违规处理数据统计">
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage2" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum2" @handleSizeChange="handleSizeChange2" @handleCurrentChange="handleCurrentChange2">
        </pagination>
      </div>
    </div>

    <div class="page">
      <section class="seaerch-wrapper" style="padding: 0px;margin-bottom: 0px;">
        <h1>
          人员-操作时段统计
        </h1>
        <el-form class="search-form" style="margin-left: -30px;">
          <el-form-item label="全部人员" :label-width="formLabelWidth">
            <el-select v-model="userids3" placeholder="请选择" size="small" clearable multiple>
              <el-option
                v-for="item in statisticalArr"
                :key="item.id"
                :label="item.realname"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="统计时间" :label-width="formLabelWidth">
            <el-date-picker
              size="small" clearable
              v-model="searchformDate3"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button size="small" clearable class="search-btn" @click="oneStep3()">查询</el-button>
          </el-form-item>
        </el-form>
      </section>
      </el-row>
      <el-table :data="tableData3" style="width: 100%;margin-top: 5px;" v-loading="tableLoading3" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="username" label="人员">
        </el-table-column>
        <el-table-column prop="syncdatetimeframe" label="时段" width="310">
        </el-table-column>
        <el-table-column prop="brmnum" label="品牌">
        </el-table-column>
        <el-table-column prop="itemlistnum" label="商品入库">
        </el-table-column>
        <el-table-column prop="markingnum" label="打标">
        </el-table-column>
        <el-table-column prop="lowpricenum" label="违规">
        </el-table-column>
        <el-table-column prop="lowpriceexcelnum" label="违规数据下载数埋点">
        </el-table-column>
        <el-table-column prop="synchronousnum" label="违规同步点击数">
        </el-table-column>
        <el-table-column prop="synchronousbannum" label="禁售同步点击数">
        </el-table-column>
        <el-table-column prop="noticenum" label="通知">
        </el-table-column>
        <el-table-column prop="noticeexcelnum" label="通知数据下载数">
        </el-table-column>
        <el-table-column prop="reviewnum" label="复查">
        </el-table-column>
        <el-table-column prop="reviewclicknum" label="复查数据点击数">
        </el-table-column>
        <el-table-column prop="reviewtimeoutnum" label="复查超时">
        </el-table-column>
        <el-table-column prop="complaintsexcelnum" label="投诉报表下载数">
        </el-table-column>
        <el-table-column prop="brmstandardnum" label="品牌标准模板报表">
        </el-table-column>
        <el-table-column prop="itemlistlinkexcelnum" label="重点商品链接数量统计">
        </el-table-column>
        <el-table-column prop="shopkeyexcelnum" label="各店铺重点品多件组合装平均最违规统计">
        </el-table-column>
        <el-table-column prop="aggregationexcelnum" label="线上秩序维护汇总">
        </el-table-column>
        <el-table-column prop="platformreviewexcelnum" label="每日违规各平台违规链接情况统计">
        </el-table-column>
        <el-table-column prop="shopreviewexcelnum" label="每日违规店铺违规链接情况统计">
        </el-table-column>
        <el-table-column prop="productreviewexcelnum" label="每日重点品违规链接数量统计">
        </el-table-column>
        <el-table-column prop="noticerectificationnum" label="通知整改数据统计">
        </el-table-column>
        <el-table-column prop="reviewdealwithnum" label="违规处理数据统计">
        </el-table-column>
      </el-table>
      <div v-show="this.tableData.length > 0">
        <pagination
          :currentPage="currentPage3" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum3" @handleSizeChange="handleSizeChange3" @handleCurrentChange="handleCurrentChange3">
        </pagination>
      </div>
    </div>

  </div>
</template>

<script>
  import pagination from "../../components/dataTable/pagination";
  export default {
    data() {
      return {
        formLabelWidth: "100px",
        statistical: 1,
        statisticalArr: [],
        tableLoading:false,
        tableLoading2:false,
        tableLoading3:false,
        downTableTrue:false,
        downTableTrue2:false,
        tableData: [],
        tableData2: [],
        tableData3: [],
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        pageNo2: 1,
        pageSize2: 10,
        currentPage2: 1,
        pageNo3: 1,
        pageSize3: 10,
        currentPage3: 1,
        totalNum: 10,
        totalNum2: 10,
        totalNum3: 10,
        status:'',
        searchformDate: [],//时间
        searchformDate2: '',//时间
        searchformDate3: '',//时间
        userids: [],
        userids2: [],
        userids3: [],
        sort: 1,
      }
    },
    mounted() {
      this.getuserinAll()
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.oneStep();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.oneStep();
      },

      handleSizeChange2(val) {
        this.pageSize2 = `${val}`
        this.oneStep2();
      },
      handleCurrentChange2(val) {
        this.pageNo2 = `${val}`
        this.oneStep2();
      },

      handleSizeChange3(val) {
        this.pageSize3 = `${val}`
        this.oneStep3();
      },
      handleCurrentChange3(val) {
        this.pageNo3 = `${val}`
        this.oneStep3();
      },
      // 下载
      downTable(type) {
        let that = this;
        let datas = {}
        let url
        let name
        if (type == 1) {
          that.downTableTrue = true
          url = ''
          name = '人员-操作行为数据.xlsx'
          datas.type = 1
          if (this.searchformDate2) {
            datas.syncdatemonth = this.$options.filters['fullTime'] (this.searchformDate2).substring(0,7)
          }
          if (this.userids.length != 0) {
            datas.userids = this.userids.join(',')
          }
        } else if (type == 2) {
          that.downTableTrue2 = true
          url = ''
          name = '人员-操作行为数据.xlsx'
          datas.type = 2
          if (this.userids2.length != 0) {
            datas.userids = this.userids2.join(',')
          }
          if (this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10) == 'NaN-NaN-Na') {
            datas.starttime = ''
          } else {
            datas.starttime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10);
          }
          if (this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10) == 'NaN-NaN-Na') {
            datas.endtime = ''
          } else {
            datas.endtime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10);
          }
        }
        fetch({
          url: "hcm/hcmBrmanalysis/hcmUseranalysisDownload",
          method: "get",
          params: datas,
          noFormat: true,
          responseType: "blob",
          timeout: 60 * 1000 * 5
        }).then(res => {
          //下载
          let url = window.URL.createObjectURL(new Blob([res]));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", name);
          document.body.appendChild(link);
          link.click();
          if (type == 1) {
            that.downTableTrue = false
          } else {
            that.downTableTrue2 = false
          }
        });
      },
      getuserinAll() {
        fetch({
          url: "hcm/userin/getbyUserid",
          method: "get",
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.statisticalArr = res.data
            this.oneStep()
            this.oneStep2()
            this.oneStep3()
          } else {
            this.$message.error(res.message)
          }
        })
      },
      sortChange() {
        if (this.sort == 1) {
          this.sort = 2
        } else {
          this.sort = 1
        }
        this.oneStep()
      },
      // 数据源
      oneStep() {
        this.tableLoading = true
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          type: 1,
          sort: this.sort,
        }
        if (this.searchformDate2) {
          params.syncdatemonth = this.$options.filters['fullTime'] (this.searchformDate2).substring(0,7)
        }
        if (this.userids.length != 0) {
          params.userids = this.userids.join(',')
        }
        fetch({
          url: "hcm/hcmUseranalysis/getbyUseranalysis",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableLoading = false
            this.tableData = data.content
            this.totalNum = data.totalElements
          } else {
            this.tableLoading = false
            this.$message.error(res.message)
          }
        })
      },
      // 数据源
      oneStep2() {
        this.tableLoading2 = true
        let params={
          pageNo: this.pageNo2,
          pageSize: this.pageSize2,
          type: 2,
          sort: 1,
        }
        if (this.userids2.length != 0) {
          params.userids = this.userids2.join(',')
        }
        if (this.searchformDate) {
          if (this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10) == 'NaN-NaN-Na') {
            params.starttime = ''
          } else {
            params.starttime = this.$options.filters['fullTime'] (this.searchformDate[0]).substring(0,10);
          }
          if (this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10) == 'NaN-NaN-Na') {
            params.endtime = ''
          } else {
            params.endtime = this.$options.filters['fullTime'] (this.searchformDate[1]).substring(0,10);
          }
        }
        fetch({
          url: "hcm/hcmUseranalysis/getbyUseranalysis",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableLoading2 = false
            this.tableData2 = data.content
            this.totalNum2 = data.totalElements
          } else {
            this.tableLoading2 = false
            this.$message.error(res.message)
          }
        })
      },
      // 数据源
      oneStep3() {
        this.tableLoading3 = true
        let params={
          pageNo: this.pageNo3,
          pageSize: this.pageSize3,
          type: 3,
          sort: 1,
        }
        if (this.searchformDate3) {
          if (this.$options.filters['fullTime'] (this.searchformDate3).substring(0,10) == 'NaN-NaN-Na') {
            params.starttime = ''
          } else {
            params.starttime = this.$options.filters['fullTime'] (this.searchformDate3).substring(0,10);
          }
          if (this.$options.filters['fullTime'] (this.searchformDate3).substring(0,10) == 'NaN-NaN-Na') {
            params.endtime = ''
          } else {
            params.endtime = this.$options.filters['fullTime'] (this.searchformDate3).substring(0,10);
          }
        }
        if (this.userids3.length != 0) {
          params.userids = this.userids3.join(',')
        }
        fetch({
          url: "hcm/hcmUseranalysis/getbyUseranalysis",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableLoading3 = false
            this.tableData3 = data.content
            this.totalNum3 = data.totalElements
          } else {
            this.tableLoading3 = false
            this.$message.error(res.message)
          }
        })
      },
    },
    components: {
        pagination
    }
  }
</script>
<style scoped lang="scss">
  .header {
    width: 100%;
    height: 28px;
    line-height: 28px;
    background-color: white;
  }
  .page {
    margin: 20px 20px 10px 20px;
    background-color: white;
  }
  .page2 {
    margin: 0px 20px 10px 20px;
    background-color: white;
    padding: 20px;
  }
  .block {
    text-align: right;
    margin-top: 20px;
  }
  .widthStyle {
    margin: 0px 0px 15px 10px;
    width: 70%;
  }
</style>
<style lang="scss">
#systemFeedback {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-button+.el-button {
    margin-left: 0px;
  }
  .bottom_page .el-pagination {
    text-align: right;
    margin-top: 0px;
    padding-bottom: 0px;
  }
}
</style>
